import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from "react";
import { TextField, Grid } from "@mui/material";
import { toast } from "react-toastify";
import RolesApi from "../../../infrastructure/api/pages/roles-api";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomModal from "../modal/CustomModal";
const RoleFormSubmit = ({ open, onClose, GetRoles, initialFormData, data, title }) => {
    const [saving, setSaving] = useState(false);
    const { t: translate } = useTranslation();
    const hiddenButtonRef = useRef(null);
    const handleSaveButtonClick = () => {
        // Trigger click event on the hidden button
        if (hiddenButtonRef.current) {
            hiddenButtonRef.current.click();
        }
    };
    const validationSchema = yup.object({
        name: yup.string().required(translate("NameRequired")),
    });
    const { reset, handleSubmit, control, register, formState: { errors }, } = useForm({
        resolver: yupResolver(validationSchema),
    });
    const onCloseModal = () => {
        reset(initialFormData);
        onClose();
    };
    const onSubmit = (data) => {
        try {
            if (data.id && data.id != "") {
                setSaving(true);
                RolesApi.updateRole(data)
                    .then((response) => {
                    if (response.status === 200 && response.data != null) {
                        toast.success(translate("UpdatedSuccessfully"));
                        onCloseModal();
                        GetRoles();
                        reset(initialFormData);
                    }
                })
                    .finally(() => {
                    setSaving(false);
                });
            }
            else {
                setSaving(true);
                data.id = "";
                RolesApi.createRole(data)
                    .then((response) => {
                    if (response.status === 200 && response.data != null) {
                        toast.success(translate("SavedSuccessfully"));
                        onCloseModal();
                        GetRoles();
                        reset(initialFormData);
                    }
                })
                    .finally(() => {
                    setSaving(false);
                });
            }
        }
        catch (error) {
            toast.error(translate("Internal Server Error"));
            setSaving(false);
            onCloseModal();
            reset(initialFormData);
        }
    };
    useEffect(() => {
        reset(data);
    }, [data]);
    return (_jsx(_Fragment, { children: _jsx(CustomModal, { open: open, onClose: onCloseModal, size: "sm", saving: saving, handleSaveButtonClick: handleSaveButtonClick, heading: title, saveButtonText: translate("Save"), disabled: false, children: _jsx(Grid, { container: true, spacing: 0, children: _jsx(Grid, { size: {
                        lg: 8,
                        xs: 12
                    }, sx: {
                        mx: "auto"
                    }, children: _jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [_jsx("input", Object.assign({ type: "hidden" }, register("id"))), _jsx(Controller, { name: "name", control: control, defaultValue: data.name, render: ({ field }) => {
                                    var _a;
                                    return (_jsx(TextField, Object.assign({ label: translate("Name"), variant: "outlined", fullWidth: true, margin: "normal" }, field, { error: !!errors.name, helperText: (_a = errors.name) === null || _a === void 0 ? void 0 : _a.message })));
                                } }), _jsx("button", { ref: hiddenButtonRef, type: "submit", hidden: true, children: "Submit" })] }) }) }) }) }));
};
export default RoleFormSubmit;
